export default __webpack_public_path__ + "static/media/ic_sound.616cd76e.png";